import { useSelection } from "@frend-digital/centra/client";
import { CustomAdapter, EventSubscription } from "@frend-digital/events/client";
import { centraGTMAdapter } from "@frend-digital/events/gtm";
import { useMemo } from "react";

const logAdapter = () =>
  new CustomAdapter((e) => {
    console.log(e.event, e.data);
  });

const Events = () => {
  const { data: selection } = useSelection();

  const adapters = useMemo(
    () => [centraGTMAdapter({ selection }), logAdapter()],
    [selection]
  );

  return <EventSubscription adapters={adapters} />;
};

export default Events;
